import { createNamespacedHelpers } from 'vuex';
import dayjs from 'dayjs';
import TripItem from '@/components/trip_item/TripItem.vue';
import ModalReservationForm from '@/components/modal_reservation_form/ModalReservationForm.vue';
import IconBeach from '@/assets/icons/beach.svg';
import LayoutDefs from '@/store/layout/layout.d';
import TripDefs from '@/store/trip/trip.d';

const {
  mapActions: mapTripActions,
  mapState: mapTripState
} = createNamespacedHelpers('Trip');
const {
  mapState: mapLayoutState,
  mapActions: mapLayoutActions
} = createNamespacedHelpers('Layout');

export default {
  name: 'TripList',
  components: { IconBeach, ModalReservationForm, TripItem },
  data: () => ({
    currentFilter: 'upcoming',
    selectedBookingId: ''
  }),

  methods: {
    ...mapLayoutActions({
      layoutStore_openModal: LayoutDefs.actions.openModal
    }),

    ...mapTripActions({
      tripStore_cancelRestaurantBooking:
        TripDefs.actions.cancelRestaurantBooking,
      tripStore_getRestaurantBooking: TripDefs.actions.getRestaurantBooking
    }),

    handleOnEditClicked: function(bookingId) {
      this.selectedBookingId = bookingId;
      this.layoutStore_openModal({ module: 'editReservationForm' });
    },

    handleOnDeleteClicked: function(bookingId) {
      this.tripStore_cancelRestaurantBooking(bookingId);
      this.tripStore_getRestaurantBooking();
    },

    sortTripDescending: (item1, item2) =>
      dayjs(item1.reservationDateTime).diff(
        dayjs(item2.reservationDateTime),
        'minutes'
      ),

    sortTripAscending: (item1, item2) =>
      dayjs(item2.reservationDateTime).diff(
        dayjs(item1.reservationDateTime),
        'minutes'
      )
  },

  computed: {
    ...mapTripState({
      trips: state => state.trips
    }),

    ...mapLayoutState({
      modal: state => state.modal
    }),

    /**
     * Upcoming Trips
     * The trips that will coming in near future
     */
    upcomingTrips: function() {
      const now = dayjs();
      return this.trips
        .filter(
          trip => dayjs(trip.reservationDateTime).diff(now, 'minutes') > 0
        )
        .sort(this.sortTripDescending);
    },

    /**
     * Completed Trips
     * The trips that already happened in the past
     */
    completedTrips: function() {
      const now = dayjs();
      return this.trips
        .filter(
          trip => dayjs(trip.reservationDateTime).diff(now, 'minutes') < 0
        )
        .sort(this.sortTripAscending);
    },

    selectedTrips: function() {
      if (this.currentFilter === 'upcoming') return this.upcomingTrips;
      return this.completedTrips;
    }
  }
};
